import { Controller } from '@hotwired/stimulus';
import { showToast, clearToasts } from '../lib/toastr';

// Displays flash messages via toastr on connect.
// Works with both full page loads and Turbo navigations.
//
// Usage:
//   <div data-controller="flash"
//        data-flash-messages-value='[{"type":"success","message":"Done!"}]'>
//   </div>
export default class FlashController extends Controller {
  static values = {
    messages: { type: Array, default: [] },
    title: { type: Array, default: [] },
  };

  connect() {
    this.messagesValue.forEach(({ type, message, title }) => {
      showToast(type, message, title);
    });
  }

  // Clean up toastr containers before Turbo caches the page
  // to prevent ghost toasts from reappearing on back navigation
  teardown() {
    clearToasts();
  }

  // Design system preview: trigger a toast from a button click
  preview({ currentTarget }) {
    const { toastType, toastMessage, toastTitle } = currentTarget.dataset;
    showToast(toastType, toastMessage, toastTitle);
  }
}
